import { render, staticRenderFns } from "./UCIcon.vue?vue&type=template&id=10f5ca7d&"
import script from "./UCIcon.vue?vue&type=script&lang=ts&"
export * from "./UCIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UCIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports